import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconLinkedinShare = ({
  title = "Linkedin share",
  viewBoxWidth = 18,
  viewBoxHeight = 17,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      d="M18 17h-3.9v-6.1c0-1.6-.5-2.6-2-2.6-1 0-1.6.7-1.9 1.4l-.1.9V17H6.2V5.5h3.9v1.7c.5-.8 1.4-2 3.5-2C16 5.3 18 7 18 10.5V17zM2.2 4C.7 4 0 3 0 2 0 .9.9 0 2.2 0c1.3 0 2.1.9 2.1 2 0 1-.8 2-2.1 2zM4 17H.2V5.5h3.9V17z"
      fill="#0077B5"
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconLinkedinShare
